import { Play, Search, Sparkle } from '@audio-network/componentlibrary/icons'
import { Trans, useTranslation } from 'next-i18next'
import React from 'react'

import Link from '@/components/shared/Link'

import styles from './EmptyStateOptionComponent.module.css'
import { EmptyStateOptionProps } from './EmptyStatePlugin.types'

export const EmptyStateOption = ({
	onClose,
}: EmptyStateOptionProps): JSX.Element => {
	const { t } = useTranslation(['search'])

	const handleClick = (): void => {
		onClose?.()
	}

	// Extract link text from translation for href and onClick
	const descriptionText = t('empty-state.card-description-1')
	const linkMatch = descriptionText.match(/<a>(.*?)<\/a>/)
	const linkText = linkMatch && linkMatch[1]

	return (
		<li className={styles['empty-state-item']} data-testid="empty-state">
			<div className={styles['empty-state-title']}>
				{t('empty-state.title')}
			</div>
			<div className={styles['search-methods-grid']}>
				{/* Prompt or Scene */}
				<div className={styles['search-method-card']}>
					<div className={`${styles['icon-bg']} ${styles['icon-sparkle']}`}>
						<Sparkle />
					</div>
					<div className={styles['search-method-card-content']}>
						<div className={styles['method-title']}>
							{t('empty-state.card-title-1')}
						</div>
						<div className={styles['method-description']}>
							<Trans
								components={{
									a: (
										<Link
											href={`/track/searchkeyword?searchByPrompt=${encodeURIComponent(
												linkText
											)}`}
											onClick={() => handleClick()}
											className={styles['example-link']}
										/>
									),
								}}
							>
								{t('empty-state.card-description-1')}
							</Trans>
						</div>
					</div>
				</div>

				{/* Reference track */}
				<div className={styles['search-method-card']}>
					<div className={`${styles['icon-bg']} ${styles['icon-link']}`}>
						<Play />
					</div>
					<div className={styles['search-method-card-content']}>
						<div className={styles['method-title']}>
							{t('empty-state.card-title-2')}
						</div>
						<div className={styles['method-description']}>
							{t('empty-state.card-description-2')}
						</div>
					</div>
				</div>

				{/* Keywords */}
				<div className={styles['search-method-card']}>
					<div className={`${styles['icon-bg']} ${styles['icon-piano']}`}>
						<Search />
					</div>
					<div className={styles['search-method-card-content']}>
						<div className={styles['method-title']}>
							{t('empty-state.card-title-3')}
						</div>
						<div className={styles['method-description']}>
							{t('empty-state.card-description-3')}
						</div>
					</div>
				</div>
			</div>
		</li>
	)
}
